import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ShieldCheck, Loader2, CheckCircle2 } from 'lucide-react';
import SastraLogo from '../FrontOffice/components/SastraLogo';
import './LogoutCard.css';

const LogoutCard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto navigate back to home after 2.5 seconds
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="logout-overlay" role="region" aria-label="Écran de déconnexion">
      {/* Background ambient lighting */}
      <div className="logout-glow-orb logout-glow-orb-1" />
      <div className="logout-glow-orb logout-glow-orb-2" />

      {/* Main glassmorphic card */}
      <div className="logout-card">
        <div className="logout-card-accent-line" />

        {/* Header with Logo and Security Badge */}
        <div className="logout-brand-header">
          <div className="logout-brand-logo">
            <SastraLogo size={32} />
          </div>
          <div className="logout-badge-security">
            <span className="logout-status-dot" />
            <ShieldCheck size={14} />
            <span>DÉCONNEXION SÉCURISÉE</span>
          </div>
        </div>

        {/* Central Icon */}
        <div className="logout-icon-box" aria-hidden="true">
          <LogOut size={32} strokeWidth={2.2} />
        </div>

        {/* Greeting & Message */}
        <h1 className="logout-title">Déconnexion réussie</h1>
        <p className="logout-subtitle">
          Votre session a été clôturée en toute sécurité. Nous vous remercions pour votre travail et votre engagement.
        </p>

        {/* Progress bar & status */}
        <div className="logout-progress-section">
          <div className="logout-progress-track">
            <div className="logout-progress-fill" />
          </div>
          <div className="logout-status-message" role="status" aria-live="polite">
            <Loader2 size={16} className="logout-spinner-mini" />
            <span>Fermeture de votre session sécurisée…</span>
          </div>
        </div>

        {/* Signature */}
        <div className="logout-footer">
          <CheckCircle2 size={14} className="logout-footer-icon" />
          <span>Session clôturée — <strong>L'Équipe IT Sastra Energy</strong></span>
        </div>
      </div>
    </div>
  );
};

export default LogoutCard;
